import { setPostStyleGuideTheme } from "@insite/client-framework/ThemeConfiguration";
import * as styleguide from "@store/theme/styleguide";

setPostStyleGuideTheme(styleguide as any);
